import http from "./httpService";
import { apiUrl, tokenKeyName, refreshKeyName } from "../config";
import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";
import {
  accesses,
  divisionAccesses,
  errorCodes,
  featureAccesses,
  localStorageVariables,
  pages,
} from "../constants";

export function login(userName, password) {
  let re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (re.test(userName)) {
    return http.post(`${apiUrl}Account/CustomerLogin`, { userName, password });
  } else {
    return http.post(`${apiUrl}Account/Login`, { userName, password });
  }
}

//for refreshing access token
export function refreshToken() {
  // console.log(refreshKeyName);
  return http.post(`${apiUrl}Account/RefreshAccess`, "", {
    headers: { refreshToken: localStorage.getItem(refreshKeyName) },
  });
}

export function logout() {
  localStorage.removeItem(tokenKeyName);
  localStorage.removeItem(refreshKeyName);
}

export function isAuthenticated(
  accessToCheck,
  customersCanAccess,
  pathname,
  statusCheck,
  customerOnly,
  allowedDivisionAccesses
) {
  const token = localStorage.getItem(tokenKeyName);
  // console.log(pathname);
  //if a token exists, check to see if it is expired.
  //if it's expired, delete it and return false.
  //if not, return it.

  //Error Codes:
  //333: invalid token
  if (token) {
    let decodedToken;
    try {
      decodedToken = jwtDecode(localStorage.getItem(tokenKeyName));
      const currentTime = Date.now();
      // console.log(decodedToken); //current time in milliseconds (from epoch)
      // console.log(decodedToken.exp * 1000); //expiration of jwt in milliseconds from epoch
      // console.log(decodedToken.exp * 1000 - currentTime); //expiration of jwt minus current time gives us how many milliseconds jwt is valid for.
      // console.log(new Date(decodedToken.exp * 1000)); // datetime jwt will expire
      // console.log((decodedToken.exp * 1000 - currentTime) / (1000 * 60)); //minutes jwt is valid for
      // console.log(decodedToken.exp * 1000 - currentTime); //if the expiration of the jwt minus the current time is 0 or less, then the jwt has expired.
      //if our jwt is expired, delete the token and log us out
      if (decodedToken.exp * 1000 - currentTime <= 0) {
        localStorage.removeItem(tokenKeyName);
        toast.error("Session Expired. Please sign in again.");
        return false;
      }
    } catch (ex) {
      //in case they try to manually enter a token that cannot be decoded, and the jwtdecode fails:
      localStorage.removeItem(tokenKeyName);
      toast.error("Session Expired. Please sign in again. (333)");
      return false;
    }
    //if token exists, can be decoded, and is not expired, check if user has appropriate access

    if (decodedToken[accesses.Admin]) {
      return token;
    }

    //if no access to check, then return token,

    if (!customersCanAccess && !isClient()) {
      return false;
    }
    if (customersCanAccess && !isClient()) {
      return token;
    }
    if (customerOnly) {
      return isClient() ? false : token;
    }

    if (!hasDivisionAccess(decodedToken, allowedDivisionAccesses)) {
      // console.log(allowedDivisionAccesses);
      return false;
    }

    if (!accessToCheck) {
      // console.log("No access to check passed, so anyone can access");
      return token;
    }
    if (accessToCheck === accesses.Base) {
      // console.log("Only base access is needed so anyone can access");
      return token;
    }
    //want access levels for developers / diligent master accounts as well, temporary check for our test clientid:
    if (accessToCheck === accesses.Developer) {
      // console.log("Need developer access");
      // console.log(decodedToken.ClientId);
      if (decodedToken.ClientId === 22622) {
        return token;
      } else {
        return false;
      }
    }

    //if they are trying to access a CDK page and are a cdk client, let them access the page, else return false.
    //This takes precedence over the IsMainAccount and Admin, as a client can be those things and still not have access to cdk.
    if (accessToCheck === featureAccesses.IsCdkClient) {
      if (
        decodedToken.IsCdkClient || //probably re-add this once our tokens are short lived and refresh token system is working
        statusCheck
      ) {
        return token;
      } else {
        return false;
      }
    }
    // console.log(decodedToken.IsMainAccount);
    if (decodedToken[accesses.IsMainAccount]) {
      // console.log("I am Main Account or Admin so i can access");
      return token;
    }
    //if the above didn't return and the access needed is IsMainAccount then we want to show a toast making them aware about it.
    if (accessToCheck === accesses.IsMainAccount) {
      toast.error(
        `${errorCodes.notMainAccount.errorCode}: ${errorCodes.notMainAccount.errorMessage}`,
        { autoClose: 10000 }
      );
      return false;
    }

    // console.log(decodedToken[accessToCheck]);
    if (decodedToken[accessToCheck] === true) {
      // console.log(accessToCheck);
      // console.log(decodedToken[accessToCheck]);
      // console.log("i got the access needed");
      return token;
    }

    //if none of the above is true, return false.
    // console.log("failed access check");
    toast.error(
      "You do not seem to have the correct permissions to access this page. Redirecting Now."
    );
    return false;
  } else {
    //if token does not exist return false.
    // console.log(pathname);
    if (pathname !== pages.loginPage.url) {
      toast.error("Please sign in.");
    }
    return false;
  }
}
export function isLoggedIn() {
  const token = localStorage.getItem(tokenKeyName);

  if (token) {
    let decodedToken;
    try {
      decodedToken = jwtDecode(localStorage.getItem(tokenKeyName));
      const currentTime = Date.now();
      //if token is expired, false
      if (decodedToken.exp * 1000 - currentTime <= 0) {
        return false;
      }
    } catch (ex) {
      //if error parsing token, false
      return false;
    }
  } else {
    //if no token, false,
    return false;
  }
  //if token exists, can be parsed, and is not expired, return true.
  return true;
}
export function isClient() {
  try {
    // need try/catch because it will fail if the token is not set (when they logout/are logged out/first time visitors)
    const clientId = jwtDecode(localStorage.getItem(tokenKeyName)).ClientId;
    return clientId && clientId !== 99999 ? true : false;
  } catch (ex) {
    return false;
  }
}
export function hasDivisionAccess(decodedUserToken, allowedDivisionAccesses) {
  // console.log("auth - decoded token:", decodedUserToken);
  // return true;
  const userDivisionAccesses = [];
  if (hasAccessToNetwork(decodedUserToken)) {
    userDivisionAccesses.push(divisionAccesses.network);
  }
  if (hasAccessToDedicated(decodedUserToken)) {
    userDivisionAccesses.push(divisionAccesses.dedicated);
  }
  // console.log("auth - user division accesses", userDivisionAccesses);
  let hasAccessToAnyAllowedDivision = false;
  for (let i = 0; i < userDivisionAccesses.length; i++) {
    if (allowedDivisionAccesses?.includes(userDivisionAccesses[i])) {
      hasAccessToAnyAllowedDivision = true;
    }
  }
  return hasAccessToAnyAllowedDivision;
}
export function isReadOnly(decodedUserToken) {
  return decodedUserToken.IsReadOnly;
}
export function isDemoAccount(decodedUserToken) {
  return decodedUserToken?.nameid?.toLowerCase() === "csrdemo";
}
export function hasAccessToNetwork(decodedUserToken) {
  // console.log(decodedUserToken);
  // return false;
  // return true;
  if (decodedUserToken) {
    // console.log("decodedUsertoken");
    return (
      //Currently if they are not a cdkclient then they are a network client
      //if they are a cdk client then they can be either a network client, dedicated, or both
      //May change
      !decodedUserToken.IsCdkClient ||
      (decodedUserToken.IsCdkClient && decodedUserToken.IsNetworkClient) ||
      !decodedUserToken.IsDedicatedClient //if they are not a dedicated client, just fallback to them being a network client for now. Might need to correct this if we add a division later.
    );
  } else {
    try {
      // need try/catch because it will fail if the token is not set (when they logout/are logged out/first time visitors)
      const decodedUserTokenTemp = jwtDecode(
        localStorage.getItem(tokenKeyName)
      );
      return (
        !decodedUserTokenTemp.IsCdkClient ||
        (decodedUserTokenTemp.IsCdkClient &&
          decodedUserTokenTemp.IsNetworkClient) ||
        !decodedUserToken.IsDedicatedClient //if they are not a dedicated client, just fallback to them being a network client for now. Might need to correct this if we add a division later.
      );
    } catch (ex) {
      return false;
    }
  }
}
export function hasAccessToDedicated(decodedUserToken) {
  // return true;
  // return false;
  if (decodedUserToken) {
    return (
      // decodedUserToken.IsCdkClient &&
      decodedUserToken.IsDedicatedClient
    );
  } else {
    try {
      // need try/catch because it will fail if the token is not set (when they logout/are logged out/first time visitors)
      const decodedUserTokenTemp = jwtDecode(
        localStorage.getItem(tokenKeyName)
      );
      return (
        // decodedUserTokenTemp.IsCdkClient &&
        decodedUserTokenTemp.IsDedicatedClient
      );
    } catch (ex) {
      return false;
    }
  }
}
export function isAdmin() {
  try {
    // need try/catch because it will fail if the token is not set (when they logout/are logged out/first time visitors)
    return jwtDecode(localStorage.getItem(tokenKeyName)).ClientId === 99999
      ? true
      : false;
  } catch (ex) {
    return false;
  }
}

export function isMasterClient(decodedJWTToken) {
  //check to see if masteraccount is true and master accounts will also have an employee id that is nonzero
  //one or the other is probably fine but checking both anyway
  return decodedJWTToken.MasterAccount && decodedJWTToken.EmployeeId !== 0;
}

export function getClientJWTInfo() {
  try {
    return jwtDecode(localStorage.getItem(tokenKeyName));
  } catch (ex) {
    toast.error("Issue reading authentication token.");
  }
}

export function getDropShipInfos() {
  return http.get(`${apiUrl}Account/GetDropShipInfos`);
}

export function getProfileInformation() {
  return http.get(`${apiUrl}Account/GetProfileInformation`);
}

export function getClientLocation() {
  return http.get(`${apiUrl}CdkOrder/GetOriginLocationForClient`);
}

export function updateProfile(profileInfoToUpdate) {
  return http.put(`${apiUrl}Account/UpdateProfile`, profileInfoToUpdate);
}

export function getClientList(username, password) {
  return http.get(`${apiUrl}Account/GetClientList`, {
    params: { username, password },
  });
}

export function diligentLogin(masterUserLoginBody) {
  return http.post(`${apiUrl}Account/DiligentLogin`, masterUserLoginBody);
}

export const getClientDefaultLandingPage = () =>
  http.get(`${apiUrl}Account/GetClientSettings`);

export const updateClientDefaultLandingPage = (landingPage) =>
  http.post(`${apiUrl}Account/PostClientSetting`, landingPage);

export function handleLoginToken(
  token,
  isLinkedAccount = false,
  diligentMasterUser
) {
  if (Array.isArray(token)) {
    localStorage.setItem(tokenKeyName, token[0]);
    localStorage.setItem(refreshKeyName, token[1]);
    if (!isLinkedAccount) {
      const decodedToken = jwtDecode(token[0]);
      localStorage.setItem(
        localStorageVariables.displayNameKey,
        decodedToken.given_name ?? "User"
      );
      localStorage.setItem(localStorageVariables.userid, decodedToken.nameid);
      localStorage.setItem(
        localStorageVariables.clientId,
        decodedToken.ClientId
      );
    }
  } else {
    localStorage.setItem(tokenKeyName, token);
    if (!isLinkedAccount) {
      const decodedToken = jwtDecode(token);
      localStorage.setItem(
        localStorageVariables.displayNameKey,
        diligentMasterUser ?? decodedToken.CustomerEmail ?? "User" //customers do not currently (8/30/23) have a displayname property, so we use the CustomerEmail instead
      );
      localStorage.setItem(localStorageVariables.userid, decodedToken.nameid);
      localStorage.setItem(
        localStorageVariables.clientId,
        decodedToken.ClientId
      );
    }
  }
}

//This is to tell if they are on their original account or switched to a different user for the account switching logic. Not to determine if the isMainAccount jwt field is true or false.
//basically if they are on the account they actually logged into or not.
export function isMainClientAccount(decodedToken) {
  return (
    //It is a client's main account if either the main account username does not exist on the token, indicating they just logged in, or MainAccountUsername === nameid
    //if a MainAccountUsername field is on the token, that means they've switched accounts
    //if it is equal to nameid, that means they have switched previously but switched back to the main account.
    decodedToken.MainAccountUsername === undefined ||
    decodedToken.nameid === decodedToken.MainAccountUsername
  );
}
export function isSubAccount(decodedToken) {
  return decodedToken?.MainAccountUsername;
}
//if the isMainAccount field is true, basically a client's primary/main account, that is allowed to link and switch between clients.
export function isMainAccount(decodedToken) {
  return decodedToken?.IsMainAccount;
}
export function shouldFetchAccountList(decodedToken) {
  return isMainAccount(decodedToken) || isSubAccount(decodedToken);
}
export function isAdminAccount(decodedToken) {
  return decodedToken?.ClientId === 99999;
}

export function submitSurvey(
  ClientName,
  SurveyRateOne,
  SurveyRateTwo,
  SurveyRateThree,
  SurveyRateFour,
  SurveyQuestionOne,
  SurveyQuestionTwo,
  SurveyQuestionThree,
  SurveyResponse,
  ResponseName,
  ResponsePhone,
  ResponseEmail
) {
  return http.post(`${apiUrl}Account/SendSurveyEmail`, {
    ClientName,
    SurveyRateOne,
    SurveyRateTwo,
    SurveyRateThree,
    SurveyRateFour,
    SurveyQuestionOne,
    SurveyQuestionTwo,
    SurveyQuestionThree,
    SurveyResponse,
    ResponseName,
    ResponsePhone,
    ResponseEmail,
  });
}
